<template>
    <main-content>
        <page-title title_text="ذی نفعان" icon="shareholders">
            <div class="back-flex">
                <router-link class="btn btn-success mx-2"
                         to="/shareholder/create"
                         v-text="$t('label.create_shareholder')"
                ></router-link>
                <div class="btn-width-100">
                    <router-link to="/wallets" class="btn btn-success my-2 btn-width-100">{{ $t('label.back') }}</router-link>
                </div>
            </div>
        </page-title>
        <!-- Wallets Share Holders Filter -->
        <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px;">
            <div class="row">
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input class="form-control  px-3 rounded-pill" placeholder="نام ذی نفع" type="text" name="name" v-model="name">
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input class="form-control  px-3 rounded-pill" placeholder="شناسه کیف" type="text" name="wallet_id" v-model="wallet_id">
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input class="form-control  px-3 rounded-pill" placeholder="شماره شبا" type="text" name="account_numbers" v-model="account_numbers">
                    </div>
                </div>
                <div class="col-sm my-2">
                    <button :class="'btn btn-success btn-block'" style="border-radius: 10px;" @click="get_data(shareholders.first_page_url)">اعمال فیلتر
                    </button>
                </div>
            </div>
        </div>
        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <div class="px-3">
                <div class="table-responsive" v-if="shareholders != null">
                    <table class="table table-responsive table-borderless text-center">
                        <thead>
                        <tr>
                            <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه</th>
                            <th scope="col" style="background-color: #eee;" v-text="$t('label.shareholder_name')"></th>
                            <th scope="col" style="background-color: #eee;" v-text="$t('label.wallet_hashid')"></th>
                            <th scope="col" style="background-color: #eee;" v-text="$t('label.account_number_or_sheba')"></th>
                            <th scope="col" style="background-color: #eee;" v-text="$t('label.created_at')"></th>
                            <th scope="col" style="background-color: #eee; border-radius: 16px 0 0 16px">جزییات</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(shareholder, index) in shareholders.data" :key="index">
                            <td class="en_num">{{ shareholder.id }}</td>
                            <td>{{ shareholder.first_name + ' ' + shareholder.last_name }}</td>
                            <td>{{ shareholder.wallet_hashid != ""? shareholder.wallet_hashid: '__'}}</td>
                            <td>{{ shareholder.account_numbers.length === 0 ? ' ' : shareholder.account_numbers[0] }}</td>
                            <td dir="ltr">{{ toPersianDateFormat(shareholder.created_at) }}</td>
                            <td>
                                <router-link :to="'/shareholder/update/' + shareholder.id">
                                    <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            width="20"
                                            fill="#bbb"
                                    >
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path
                                                d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                                        />
                                    </svg>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <hr v-if="shareholders && (shareholders.next_page_url || shareholders.prev_page_url)" />

            <pagination
                    v-if="shareholders"
                    :data="shareholders"
                    :get_data="get_data"
                    :perpage="perpage"
            ></pagination>
        </div>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import {ShopApiService} from "@/common/api.service";
    import Pagination from "@/components/main/pagination";
    import PageTitle from "@/components/main/components/pageTitle";

    export default {
        components: {
            mainContent,
            Pagination,
            PageTitle,
        },
        data() {
            return {
                perpage: {
                    value: 15,
                },
                shareholders: null,
                name: '',
                wallet_id: '',
                account_numbers: ''
            };
        },
        computed: {
             query() {
                let res = "";

                if (this.name != "") {
                    res = res + "&query[name]=" + this.name;
                }
                if (this.wallet_id != "") {
                    res = res + "&query[wallet_id]=" + this.wallet_id;
                }
                if (this.account_numbers != "") {
                    res = res + "&query[account_numbers]=" + this.account_numbers;
                }

                return res;
            },
        },
        methods: {
            get_data(url, callback = () => {}) {
                ShopApiService.query(url + this.query + "&perpage=" + this.perpage.value).then(json => {
                    this.shareholders = json.data.data;
                    callback();
                });
            },
            toPersianDateFormat(val) {
                if (val === undefined || val === null || val === '') {
                    return '';
                }

                val = String(val);

                return val.replace(/\-/g, '/');
            },
        },
         mounted() {
            ShopApiService.query('shareholder/paginate').then(json => {
                this.shareholders = json.data.data;
            });
        },
    }
</script>

<style scoped>
    .back-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

@media screen and (max-width:678px){
    .back-flex {
        flex-direction: column-reverse;
        align-items: center;
        justify-content: center;
    }
    .btn-width-100 {
        width: 100%;
        display: none;
    }
}
</style>